module.exports = __webpack_public_path__ + "static/media/ZEC.54eb4f8d.svg";